import { computed, type Signal } from '@angular/core';
import { injectUser } from '@quipex/core/auth';
import { getQuippySuggestions } from './prompt-suggestions';

interface SuggestionScope {
    readonly kind: 'building' | 'portfolio';
    readonly buildingId?: string;
    readonly organisationId?: string;
}

export function injectQuippySuggestions(scope: Signal<SuggestionScope>) {
    const me = injectUser();
    const context = computed(
        () => {
            const target = scope();
            const user = me();
            return {
                kind: target.kind,
                buildingId:
                    target.kind === 'building' ? target.buildingId : undefined,
                organisationId: target.organisationId ?? user?.organisationId,
                userType: user?.userType,
            };
        },
        {
            equal: (previous, current) =>
                previous.kind === current.kind &&
                previous.buildingId === current.buildingId &&
                previous.organisationId === current.organisationId &&
                previous.userType === current.userType,
        }
    );
    return computed(() =>
        getQuippySuggestions(context().kind, context().userType)
    );
}
